// The one place allowed to write a turbo-frame's Turbo-owned attributes.
//
// Since Turbo 8.0.21 (hotwired/turbo#1399) these attributes are load-bearing: clearing [src]
// cancels the frame's in-flight fetch, and [complete] decides whether a reconnecting frame
// refetches. Hand-editing them from feature code is how a patch bump silently broke chained
// modals, so route it through here instead — see docs/turbo_2.0.23_update.md.

// Points a frame at a url. Safe to call with the url the frame already has: re-setting [src]
// clears [complete] and refetches, so there is no need to blank it out first.
//
// setAttribute rather than the src property: identical on a real turbo-frame (the property
// delegates to it), but the property is inert on the plain element jsdom gives component tests.
export function loadTurboFrame(frame, url) {
  frame.setAttribute('src', url instanceof URL ? url.href : url)
}

// Returns a frame to an empty, unloaded state, optionally showing placeholder markup.
//
// This CANCELS any request the frame currently has in flight. That is the point when resetting an
// idle preview panel; do not call it while a fetch you still want is running.
export function resetTurboFrame(frame, html = '') {
  frame.innerHTML = html
  frame.removeAttribute('src')
  frame.removeAttribute('complete')
}
